<template>
  <div>
    <client-module moduletitle="自动回复设置" :hideBorder="true">
      <span slot="customHint" class="hint">当前设置主页</span>
      <div class="customer">
        <img class="photo" :src="pageData.photo" />
        <span class="name">{{ pageData.name }}</span>
      </div>
    </client-module>
    <!-- 欢迎语设置 -->
    <welcome-speech
      moduletitle="欢迎语设置"
      hint="在用户发消息给主页前，先向对方表示欢迎。你的欢迎语会在消息发送前显示在聊天窗口中，或显示在你
      Messenger 业务资料的简介版块中"
      :disabled="welcomesBtn"
      :welcomeData="pageData"
      :switchVal="welcomesSwitchVal"
      @switchChange="welcomesSwitch"
    >
      <detail-edit
        title="欢迎语"
        editIcon="el-icon-edit"
        shadow="never"
        :btnEditStyle="{
          fontSize: '20px',
          color: '#999',
        }"
        :cardStyle="cardStyle"
        :headerStyle="headerStyle"
        @submit="welcomesSubmit"
        @edit="welcomesEdit"
      >
        <div class="detail">
          {{ welcomesData.text }}
        </div>
        <div class="edit" slot="edit">
          <rich-text
            v-model="richText"
            ref="rich"
            :scope="{}"
            @change="onEditorChange($event)"
          >
            <el-select
              slot="tooltip"
              v-model="selectValue"
              placeholder="请选择"
              @change="addTag"
              size="mini"
            >
              <el-option
                v-for="item in richOptions"
                :key="item.label"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </rich-text>
          <div class="richtext-length" :style="{ color: lengthSty }">
            {{ richTextLength }}/{{ richTextTotal }}
          </div>
        </div>
      </detail-edit>
      <div class="welcome-speech-data" slot="mobile" v-if="welcomesData.id">
        {{ welcomesData.text }}
      </div>
    </welcome-speech>
    <!-- 即时回复设置 -->
    <welcome-speech
      moduletitle="即时回复设置"
      hint="回复用户通过 Messenger 发送给主页的首条消息，你可以定制消息，向对方问好，提供主页的更多信息，或告知对方何时会收到回复"
      :disabled="instantReplyBtn"
      :welcomeData="pageData"
      :switchVal="instantReplySwitchVal"
      @switchChange="instantReplySwitch"
    >
      <detail-edit
        shadow="never"
        :btnEditStyle="{
          fontSize: '20px',
          color: '#999',
        }"
        title="回复设置"
        :cardStyle="cardStyle"
        :headerStyle="headerStyle"
        @submit="instantReplySubmit"
        @edit="instantReplyEdit"
      >
        <!-- 展示 -->
        <div class="detail" v-for="item in instantReplyList" :key="item.id">
          <div class="title">
            <span>{{ item.title }}</span>
            <span v-if="item.hint" class="hint">{{ item.hint }}</span>
          </div>
          <div class="content">
            {{ item.content }}
          </div>
        </div>
        <!-- 设置 -->
        <form-combination
          ref="instantReply"
          class="edit"
          slot="edit"
          :form-data="instantReplyGroups"
          labelPosition="top"
        ></form-combination>
      </detail-edit>
      <detail-edit
        shadow="never"
        :btnEditStyle="{
          fontSize: '20px',
          color: '#999',
        }"
        title="弹窗设置"
        :cardStyle="cardStyle"
        :headerStyle="headerStyle"
        @submit="modalBoxSubmit"
        @edit="instantReplyEdit"
      >
        <!-- 展示 -->
        <div class="detail" v-for="item in modalBoxList" :key="item.id">
          <div class="title">
            <span>{{ item.title }}</span>
            <span v-if="item.hint" class="hint">{{ item.hint }}</span>
          </div>
          <div class="content">
            {{ item.content }}
          </div>
        </div>
        <!-- 设置 -->
        <form-combination
          ref="modalBox"
          class="edit"
          slot="edit"
          :form-data="modalBoxGroups"
          labelPosition="top"
        ></form-combination>
      </detail-edit>
      <div class="data-preview" slot="mobile" v-if="instantReplyData.id">
        <div class="chat-content" v-if="instantReplyData.content">
          <div class="photo">
            <img :src="pageData.photo" alt="" />
          </div>
          <div class="content">
            <div class="name">{{ pageData.name }}</div>
            <div class="text style">
              {{ instantReplyData.content }}
            </div>
          </div>
        </div>
        <div class="chat-content" v-if="instantReplyData.cpmTitle">
          <div class="photo">
            <img :src="pageData.photo" alt="" />
          </div>
          <div class="content">
            <div class="name">{{ pageData.name }}</div>
            <div class="text">
              <div class="chat-btn">
                <div class="title">{{ instantReplyData.cpmTitle }}</div>
                <div class="leftBtn">
                  <a
                    class="btn"
                    :href="instantReplyData.leftUrl"
                    target="_blank"
                    >{{ instantReplyData.leftTitle }}</a
                  >
                  <!-- <div class="btn">{{ instantReplyData.leftTitle }}</div> -->
                </div>
                <div class="rightBtn">
                  <div class="btn">{{ instantReplyData.rightTitle }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </welcome-speech>
  </div>
</template>

<script>
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
import clientModule from '@/components/client/clientModule/clientModule.vue';
import welcomeSpeech from '@/components/socialMedia/welcomeSpeech.vue';
import detailEdit from 'skytech-detail-edit';
import inputMessage from '@/components/SaaS/inputMessage.vue';
import richText from '@/components/iglobalwin/formComponents/sky-richtext';
import mediafax from '@/backend/services/account/mediafax.js';
import simpleFormPageCreate from '@/components/iglobalwin/formCombination/formService.js';
import api from '@/backend/apiConfig/apiConfig';
import { validRequired, validMax } from '@/common/elementValid';
import chatItem from '@/components/client/inquiry/chatItem.vue';

import { Quill } from 'vue-quill-editor';
const BlockEmbed = Quill.import('blots/embed');
class Audio extends BlockEmbed {
  static create(value) {
    let node = super.create(value);
    node.setAttribute('contenteditable', false);
    node.className = 'customer-tag';
    node.innerText = value;
    return node;
  }
  static value(node) {
    return node.innerText;
  }
}
Audio.blotName = 'tag';
Audio.tagName = 'span';

Quill.register(Audio);
export default {
  data() {
    return {
      cardStyle: {
        border: '1px solid transparent',
      },
      headerStyle: {
        'font-size': '16px',
        color: '#333',
        'font-weight': 'bold',
      },
      instantReplyGroups: {},
      modalBoxGroups: {},
      richOptions: [
        {
          label: '接收人名称',
        },
        {
          label: '接收人姓氏',
        },
        {
          label: '接收人全名',
        },
      ],
      selectValue: '',
      richText: '',
      instantReplyData: {},
      instantReplyList: [],
      modalBoxList: [],
      List: [],
      welcomesData: {},
      pageData: {},
      richTextLength: 0,
      richTextTotal: 160,
      statChange: true,
      lengthSty: '#333',
    };
  },
  computed: {
    instantReplyBtn() {
      return this.instantReplyData.id ? false : true;
    },
    welcomesBtn() {
      return this.welcomesData.id ? false : true;
    },
    welcomesSwitchVal() {
      if (this.welcomesData.onOff === 1) {
        return true;
      } else {
        return false;
      }
    },
    instantReplySwitchVal() {
      if (this.instantReplyData.onOff === 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.serviceId = this.$route.query.id;
    this.setGroups();
    this.getHomePageContent();
  },
  methods: {
    getQuill() {
      return this.$refs.rich.getQuill();
    },
    addTag(val) {
      let range = this.getQuill().getSelection(true);
      this.getQuill().insertEmbed(range.index, 'tag', val, Quill.sources.USER);
    },
    onEditorChange() {
      let content = this.getQuill().getContents().ops;
      let text = this.welocmesDataFormat(content).text;
      if (!text || text == '') {
        this.richTextLength = 0;
      } else {
        this.richTextLength = text.length - 1;
      }

      if (this.richTextLength > this.richTextTotal) {
        this.lengthSty = 'red';
      } else {
        this.lengthSty = '#333';
      }
    },
    // 设置groups
    setGroups(val = {}) {
      this.instantReplyGroups = {
        content: {
          label: '即时回复',
          formType: 'sky-textarea',
          maxlength: '500',
          autosize: {
            minRows: 2,
          },
          value: val.content,
          rules: [validRequired('此项必填', blur)],
        },
      };
      this.modalBoxGroups = {
        cpmTitle: {
          label: '弹窗标题内容',
          formType: 'sky-input',
          value: val.cpmTitle,
          rules: [validRequired('此项必填', blur), validMax(50)],
        },
        rightTitle: {
          label: '右侧按钮',
          type: 'custom',
          formType: inputMessage,
          message: '用户点击该按钮会被唤起自动回复邮箱，并被系统判定为询盘',
          inputStyle: {
            width: '100%',
          },
          value: val.rightTitle,
          rules: [validRequired('此项必填', blur)],
        },
        leftTitle: {
          label: '左侧按钮',
          type: 'custom',
          formType: inputMessage,
          message: '用户点击该按钮会打开一个网址链接，并被系统判定为线索',
          inputStyle: {
            width: '100%',
          },
          value: val.leftTitle,
          rules: [validRequired('此项必填', blur)],
        },
        leftUrl: {
          label: '网址链接',
          type: 'custom',
          formType: inputMessage,
          message: '左侧按钮的网址链接',
          inputStyle: {
            width: '100%',
          },
          value: val.leftUrl,
          rules: [validRequired('此项必填', blur), validMax(2000)],
        },
      };
    },
    // 获取欢迎语和即时回复
    async getHomePageContent() {
      try {
        let id = this.serviceId;
        let res = await mediafax.homePageContent(id);
        let val = res.data;
        this.pageData = {
          id: val.pageId || '',
          name: val.pageName || '',
          photo: val.pageAvatar || '',
          cid: val.cid || '',
        };
        this.instantReplyData = {
          id: val.repplyId || '',
          onOff: val.repplyOnOff || '',
          content: val.repplyContent || '',
          cpmTitle: val.repplyCpmTitle || '',
          rightTitle: val.repplyRightTitle || '',
          leftTitle: val.repplyLeftTitle || '',
          leftUrl: val.repplyLeftUrl || '',
        };
        this.setShowData(val);
      } catch (error) {
        this.setShowData();
        console.log(error);
      }
    },
    setShowData(val = {}) {
      this.welcomesData = {
        id: val.greetId || '',
        onOff: val.greetOnOff || '',
        ...this.welocmesDataFormat(val.greetContent || ''),
      };
      this.instantReplyList = [
        {
          id: 1,
          title: '即时回复内容',
          hint: '',
          content: val.repplyContent || '-',
        },
      ];
      this.modalBoxList = [
        {
          id: 1,
          title: '弹窗标题内容',
          hint: '',
          content: val.repplyCpmTitle || '-',
        },
        {
          id: 2,
          title: '右侧按钮',
          hint: '用户点击该按钮会被唤起自动回复邮箱，并被系统判定为询盘',
          content: val.repplyRightTitle || '-',
        },
        {
          id: 3,
          title: '左侧按钮',
          hint: '用户点击该按钮会打开一个网址链接，并被系统判定为线索',
          content: val.repplyLeftTitle || '-',
        },
        {
          id: 4,
          title: '网站地址',
          hint: '左侧按钮的网址链接',
          content: val.repplyLeftUrl || '-',
        },
      ];
    },
    // 设置欢迎语
    async welcomesSubmit(cb) {
      if (this.richTextLength > this.richTextTotal) {
        this.$message.warning('字符长度超出限制');
        cb(false);
        return false;
      }
      let customerName = {
        user_last_name: '接收人名称',
        user_first_name: '接收人姓氏',
        user_full_name: '接收人全名',
      };
      let content = this.getQuill().getContents().ops;
      // 无值判断
      if (content.length === 1 && typeof content[0].insert == 'string') {
        if (!content[0].insert.trim()) {
          this.$message.warning('请输入欢迎语');
          cb(false);
          return false;
        }
      }
      content.forEach((item) => {
        if (item.insert.tag) {
          Object.keys(customerName).forEach((key) => {
            if (item.insert.tag.trim() == customerName[key].trim()) {
              item.insert.tag = `{{${key}}}`;
            }
          });
        } else {
          item.insert = item.insert.trim();
        }
      });

      try {
        await this.addWelcomeSpeech(content);
        this.getHomePageContent();
        cb();
      } catch (error) {
        cb(false);
      }
    },
    // 新增欢迎语
    async addWelcomeSpeech(content) {
      let pageId = this.pageData.id;
      let id = this.welcomesData.id;
      let mediafaxId = this.serviceId;
      let status = this.welcomesData.id ? true : false;
      let res;
      if (status) {
        // 修改
        res = await mediafax.updateWelcomeSpeech({
          id,
          content,
          pageId,
        });
      } else {
        // 新增
        res = await mediafax.addWelcomeSpeech({
          content,
          mediafaxId,
        });
      }
      if (res.status == 200) {
        this.$message.success('设置成功');
      }
    },
    // 欢迎语数据格式化
    welocmesDataFormat(content) {
      if (!content) {
        return {
          text: '-',
          content: '-',
        };
      }
      let customerName = {
        user_last_name: '接收人名称',
        user_first_name: '接收人姓氏',
        user_full_name: '接收人全名',
      };
      let text = '';
      content.forEach((item) => {
        if (item.insert.tag) {
          Object.keys(customerName).forEach((key) => {
            if (item.insert.tag.trim() == `{{${key}}}`) {
              item.insert.tag = customerName[key].trim();
            }
          });
        }
        text += item.insert.tag || item.insert;
      });
      return {
        text,
        content,
      };
    },
    modalBoxSubmit(cb) {
      this.$refs.modalBox.validate((val) => {
        if (val) {
          let data = this.modalBoxGroups;
          this.submit(cb, data);
        } else {
          cb(false);
        }
      });
    },
    instantReplySubmit(cb) {
      this.$refs.instantReply.validate((val) => {
        if (val) {
          let data = this.instantReplyGroups;
          this.submit(cb, data);
        } else {
          cb(false);
        }
      });
    },
    // 设置即时回复
    submit(cb, data) {
      // 新增
      let status = this.instantReplyData.id ? true : false;
      let requestApi = api.mediafax.addInstantReply;
      let type = 'Post';
      let id = this.serviceId;
      // 修改
      if (status) {
        requestApi = `${api.mediafax.updateInstantReply}/${this.instantReplyData.id}`;
        type = 'Patch';
      }
      simpleFormPageCreate(
        {
          api: requestApi,
          type,
          data,
        },
        (res) => {
          res.mediafaxId = id;
          res.onOff = status ? this.instantReplyData.onOff : 1;
          return res;
        }
      )
        .submit()
        .then(async () => {
          await this.getHomePageContent();
          this.$message.success('设置成功');
          cb();
        })
        .catch((err) => {
          console.log(err);
          cb();
        });
    },
    instantReplyEdit(cb) {
      this.setGroups(this.instantReplyData);
      cb();
    },
    welcomesEdit(cb) {
      let content = this.welcomesData.content;
      this.getQuill().setContents(content);
      cb();
    },
    async welcomesSwitch(val) {
      let id = this.welcomesData.id;
      let res = await mediafax.updateStatus({
        id,
        onOff: val ? 1 : 2,
      });
      if (res.status == 200) {
        this.$message.success('设置成功');
      } else {
        this.getHomePageContent();
      }
    },
    async instantReplySwitch(val) {
      let id = this.instantReplyData.id;
      let res = await mediafax.updateStatus({
        id,
        onOff: val ? 1 : 2,
      });
      if (res.status == 200) {
        this.$message.success('设置成功');
      } else {
        this.getHomePageContent();
      }
    },
  },
  components: {
    clientModule,
    welcomeSpeech,
    detailEdit,
    formCombination,
    richText,
    chatItem,
  },
};
</script>
<style lang="scss">
.customer-tag {
  padding: 5px 10px;
  line-height: 30px;
  border-radius: 4px;
  border: 1px solid #cfcfcf;
  background-color: #f4f4f5;
}
</style>
<style lang="scss" scoped>
.client-module {
  background-color: #fff;
  margin-bottom: 10px;
  .customer {
    font-size: 22px;
    color: #333;
    line-height: 30px;
    display: flex;
    align-items: center;
    padding: 24px;
    .photo {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      margin-right: 20px;
    }
    .name {
      width: auto;
      font-weight: bold;
      // 单行溢出
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.hint {
  font-size: 12px;
  color: #999;
  margin-left: 10px;
}
.edit {
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  background-color: #f9f9f9;
  margin-bottom: 10px;
  .richtext-length {
    width: 100%;
    padding-top: 6px;
    font-size: 14px;
    color: #333;
    text-align: right;
  }
}
.detail {
  color: #1890ff;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 30px;
  .title {
    color: #333;
    font-weight: bold;
    margin-bottom: 15px;
    .hint {
      color: #999;
      font-size: 12px;
      font-weight: normal;
    }
  }
  .content {
    line-height: 20px;
    word-break: break-all;
  }
}
.welcome-speech-data {
  width: 100%;
  font-size: 12px;
  color: #999999;
  line-height: 16px;
  text-indent: 0px;
}
.data-preview {
  width: 100%;
  .chat-content {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    .photo {
      width: 35px;
      height: 35px;
      margin-right: 10px;
      text-indent: 0px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .content {
      max-width: 80%;
      flex: 1;
      font-size: 12px;
      color: #333;
      text-indent: 0px;
      margin-bottom: 20px;
      .name {
        margin-bottom: 5px;
        text-align: left;
        padding-right: 20px;
        // 单行溢出隐藏
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .text {
        box-sizing: border-box;
        color: #fff;
        line-height: 16px;
        border-radius: 6px;
        &.style {
          padding: 10px;
          background-color: #3da1ff;
        }
      }
    }
  }
  .chat-btn {
    width: 100%;
    background-color: #fff;
    border-radius: 6px;
    border: 1px solid #e8e8e8;
    font-size: 12px;
    .title {
      min-height: 16px;
      max-height: 50px;
      font-size: 14px;
      color: #333;
      text-align: center;
      font-weight: bold;
      margin: 10px;
      /* 多行溢出隐藏 */
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
    .leftBtn,
    .rightBtn {
      width: 100%;
      padding: 10px;
      .btn {
        width: 100%;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 6px;
        padding: 0 10px;
        // 单行溢出隐藏
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .leftBtn {
      border-top: 1px solid #e8e8e8;
      .btn {
        display: block;
        color: #fff;
        background-color: #3da1ff;
      }
    }
    .rightBtn {
      background-color: #fff;
      color: #3da1ff;
      .btn {
        border: 1px solid #3da1ff;
      }
    }
  }
}
</style>
